import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { CreationPage } from '../creation/creation';
import { AngularFire,AuthProviders, AuthMethods} from 'angularfire2';
import { AuthentificationService} from '../../providers/authentification-service';
import { MenusService } from '../../providers/menus-service';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  
})
/*
  Generated class for the Home page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
  La page Home s'occupe de gérer tout ce qu'il y a en rapport avec le login, plus l'affichage de la proposition de menu du jour
*/
export class HomePage {
  email:string;//email de l'utilisateur
  password:string;//mdp de l'utilisateur
  creationPage = CreationPage;//Page qui sera ouverte lors de la création d'un nouveau compte
  private proposition: any;//Proposition du jour pour l'utilisateur logué

  //Constructeur de home.ts
  constructor(public navCtrl: NavController,
              public af: AngularFire,
              public authentificationService: AuthentificationService,
              public menusService: MenusService) 
  {
    //On regarde l'état de l'authentification et on agit en conséquence en settant toutes les valeurs
    //Nécessitant du login comme les informations de l'utilisateur mais aussi la proposition et les favoris
    this.af.auth.subscribe(user => {
      if(user) {//Utilisateur logué
        authentificationService.setLogged(true);
        authentificationService.setUserId(user.auth.uid);
        authentificationService.setUserName(user.auth.displayName);
        authentificationService.setPhotoUrl(user.auth.photoURL);
        authentificationService.setEmail(user.auth.email);    
        menusService.setProposition();
        this.bindProposition();
        menusService.loadFavDishes();
      }
      else
      {
        authentificationService.setLogged(false);
      }
      });
  }
  //On bind la variable proposition à ce qu'on récupère depuis le MenusService
  bindProposition()
  {
    if(this.authentificationService.getLogged())
      {
          this.proposition=this.menusService.getPropositionList();
      }
  }
  //returns true if we have a proposition for the day
  CheckIfWeHaveProposition()
  {
    console.log("Check if we have a proposition");
        this.menusService.getPropositionList().then(data=>{
          console.log(data['menu']);
          if(data['menu']=="No match for today")
          {
              return Promise.resolve(false);
          }
        });
        return Promise.resolve(true);
  }
    //E-mail Login
    login(){
    firebase.database().goOnline();
    this.af.auth.login({
      email: this.email,
      password: this.password,
    },
    {
      provider: AuthProviders.Password,
      method: AuthMethods.Password,
    }).then((success)=>{
    })
  }
  //Login using Facebook
  loginWithFacebook()
  {
    firebase.database().goOnline();
    this.af.auth.login({
      provider: AuthProviders.Facebook,
      method: AuthMethods.Popup,
    }).then((success)=>{
    })
  }
  //Login using Twitter
  loginWithTwitter()
  {
    firebase.database().goOnline();
    this.af.auth.login({
      provider: AuthProviders.Twitter,
      method: AuthMethods.Popup,
    }).then((success)=>{
    })
  }
  //Login using Google
  loginWithGoogle()
  {
    firebase.database().goOnline();
    this.af.auth.login({
      provider: AuthProviders.Google,
      method: AuthMethods.Popup,
    }).then((success)=>{
    })
  }
  //Login using GitHub
  loginWithGithub()
  {
    firebase.database().goOnline();
    this.af.auth.login({
      provider: AuthProviders.Github,
      method: AuthMethods.Popup,
    }).then((success)=>{
    })
  }
  //Logout from the applicaion
  logout(){
    firebase.database().goOffline();
    this.af.auth.logout();
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts